module.exports = __webpack_public_path__ + "static/20-229125ea47715093db7a372a662e6f9c.png";